import { APIClient } from 'cx-api-client-lite';

const DeltaConfig = new APIClient({
  fetchDeltaConfig: {
    method: 'GET',
    path: 'config-delta/v2/apps/cr-spa-registration/config_delta',
  },
});

export default DeltaConfig;
